import { callBackendApi } from "../../../components/service/axios";

export const getReviewTicket = async (reviewId) => {
  return await callBackendApi("get", `/bff/tickets?reviewId=${reviewId}`);
}


export const sendGetUserAccessDataEmail = async (appId) => {
  return await callBackendApi("post", `/bff/apps/${appId}/request-user-data-email`);
};

export const startReview = async (appId) => {
  return await callBackendApi("post", `/bff/applications/${appId}/start-of-review`);
};

export const previewDataBeforeStartReview = async (appId) => {
  return await callBackendApi("get", `/bff/applications/${appId}/pre-review`);
};

export const closeReview = async (appId, comment) => {
  return await callBackendApi("post", `/bff/applications/${appId}/closure-of-review`, {
    comment: comment,
  });
};

export const cancelReview = async (appId, comment) => {
  return await callBackendApi("post", `/bff/applications/${appId}/review-cancel`, {
    comment: comment,
  });
};

export const getSavedReviewTasks = async (reviewId) => {
  return await callBackendApi("get", `/bff/review-tasks/saved?reviewId=${reviewId}`);
}
